import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Checkbox } from 'semantic-ui-react';
import Button from 'components/elements/buttons/Button';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import './ConnectStripeStep1.css';

function ConnectStripeStep1(props) {
  const { setActiveStep } = props;
  const [isAgree, setIsAgree] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="connect-stripe-step1__component">
      <div className="header">{t("Connect your Stripe account")}</div>

      <div className="text">
        <div>
          {t("To collect money from your sales, you need to connect " +
             "your bank account via Stripe. All transactions will " +
             "incur payment processing fees as follows")}:
        </div>
        <div>
          <div>{t("PRO accounts: 3.9% + 30c")}</div>
          <div>{t("STARTER accounts: 5.9%+30c")}</div>
        </div>
        <div>
          <div>{t("All fees include Stripe processing fee.")}</div>
          <div>{t("So there are no other hidden fees!")}</div>
        </div>
      </div>

      <div className="checkbox-wrapper">
        <Checkbox
          checked={isAgree}
          onChange={() => setIsAgree(!isAgree)}
        />
        <div className="label">
          {t("I agree to HeyLink.me")}&nbsp;
          <a
            href={`${PUBLIC_SITE_URL}/terms/`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Terms")}
          </a> &&nbsp;
          <a
            href={`${PUBLIC_SITE_URL}/privacy/`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Policies")}
          </a>
        </div>
      </div>

      <div className="buttons-block">
        <Button
          small
          borderedBlue
          onClick={() => setActiveStep('select-provider')}
        >
          &#10094;&nbsp;&nbsp;{t("Back")}
        </Button>
        <Button
          small
          onClick={() => setActiveStep('stripe-step-2')}
          disabled={!isAgree}
        >
          {t("Next")}
        </Button>
      </div>
    </div>
  );
}

ConnectStripeStep1.propTypes = {
  setActiveStep: PropTypes.func.isRequired,
};

export default ConnectStripeStep1;
